module.exports = "/images/pillCoin.png?21263f8043edc0d1650964b213849313";